<template>
  <v-card class="mt-4">
    <v-card-title class="text-center justify-center">
      Withdraw
    </v-card-title>

    <v-card-text>
      <p>
        Withdraw from your wallet.
        <span v-if="walletBalance"> Current balance: <b>Ksh {{ walletBalance }}</b></span>
      </p>
      <p
        v-if="destination"
        class="text--secondary"
      >
        Funds will be sent to {{ destinationLabel }}: <b>{{ destination }}</b>
      </p>
      <v-alert
        v-else
        type="warning"
        dense
        outlined
      >
        No withdrawal destination has been set up yet. Add one under Settings before withdrawing.
      </v-alert>
      <v-form
        v-model="isFormValid"
        @submit.prevent="withdraw"
      >
        <v-text-field
          v-model="form.amount"
          label="Amount"
          type="number"
          placeholder="Ksh 100"
          :rules="numberRules"
          :error="form.errors.has('amount')"
          :error-messages="form.errors.get('amount')"
          outlined
        />

        <v-btn
          color="primary"
          class="mt-4"
          type="submit"
          :loading="form.busy"
          :disabled="!destination"
          block
        >
          Withdraw
        </v-btn>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import Form from 'vform'
import validationRules from '@/mixins/validationRules'

export default {
  name: 'WithdrawalForm',
  mixins: [validationRules],
  props: {
    walletBalance: {
      type: [Number, String],
      default: null,
    },
    destination: {
      type: String,
      default: null,
    },
    destinationType: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isFormValid: true,
      form: new Form({
        amount: '',
      }),
    }
  },
  computed: {
    destinationLabel() {
      const labels = {
        phone_number: 'phone number',
        paybill_number: 'paybill number',
        till_number: 'till number',
      }

      return labels[this.destinationType] || 'destination'
    },
  },
  methods: {
    withdraw() {
      if (!this.isFormValid) return

      this.form.post('wallet/withdraw')
        .then(response => {
          this.$notification.success(response.data.message)
          this.$emit('balanceUpdated')
          this.form.reset()
        })
        .catch(error => {
          this.$notification.error(error.response?.data?.message || 'An error occurred during withdrawal')
        })
    },
  },
}
</script>
